import { useState, useCallback, useEffect } from 'react'
import { OwcIcon, OwcIconButton, OwcListItem } from "@one/react";
import { Tooltip } from "@mui/material";
import { withApollo } from 'react-apollo';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getUserDetail, getLPMyLabFilter } from '../equipment-list/LoadEquipmentService';
import { UPDATE_DIGITAL_LAB_BOOKING_USER_PROFILE_PERSONAL_FIELDS } from '../../gql/bookingapi';

function GroupListItem({ item, handleRedirect, client, isMini, ...props }) {
  const { onClick } = props;
  const [isEdit, setIsEdit] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const [filterList, setFilterList] = useState([]);
  const user = useSelector((store) => store.user);
  const location = useLocation();

  const loadFilterData = useCallback(async () => {
    if (!user?.site || !user?.id || !isExpanded) return;

    try {
      const userDetail = await getUserDetail(client, user);
      const myLabFilterMaster = await getLPMyLabFilter(client)
      const filters = [myLabFilterMaster || [], ...userDetail?.userFilters || []];

      const storedVisibility = typeof userDetail?.groupFilterVisibility === 'string'
        ? JSON.parse(userDetail.groupFilterVisibility)
        : userDetail?.groupFilterVisibility || {};
      const formattedFilters = filters.map(f => {
        const isChecked = storedVisibility[f.filterName] !== undefined
          ? storedVisibility[f.filterName]
          : (f.sharedWithGroups);
        return {
          ...f,
          filterId: f.filterName,
          filterName: f.filterName,
          isChecked: isChecked,
        };
      });
      setFilterList(formattedFilters);
    } catch (error) {
      console.error("Error loading filter data:", error);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client, user?.site, user?.id, isExpanded]);

  useEffect(() => {
    loadFilterData(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadFilterData, user?.id, isExpanded]);

  const handleToggleEdit = useCallback(async (e) => {
    e.stopPropagation();
    if (isEdit) { // When switching from edit mode to view mode
      try {
        const newVisibility = filterList.reduce((acc, curr) => {
          acc[curr.filterName] = curr.isChecked;
          return acc;
        }, {});

        await client.mutate({
          mutation: UPDATE_DIGITAL_LAB_BOOKING_USER_PROFILE_PERSONAL_FIELDS,
          variables: {
            id: user.id,
            email: user.email,
            groupFilterVisibility: JSON.stringify(newVisibility),
          }
        });
      } catch (error) {
        console.error("Error updating user profile:", error);
      }
    } else {
      loadFilterData();
    }
    setIsEdit(!isEdit);
  }, [isEdit, filterList, user, client, loadFilterData]);

  return (
    <div>
      <OwcListItem
        selected={location.pathname.startsWith(item.url)}
        noBorder
        disabled={item.disable}
        onClick={() => {
          onClick(item)
          setIsExpanded(!isExpanded);
        }}
      >
        <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
          {typeof item.icon === "string" ? <OwcIcon name={item.icon} type="legacy" /> : <div>{item.icon}</div>}
          <span style={{ marginLeft: 15 }}>{item.text}</span>
          <Tooltip title="Edit">
            <OwcIconButton
              style={{ marginLeft: "auto", width: "40px", height: "40px" }}
              onClick={handleToggleEdit}
              icon={isEdit ? "confirm" : "edit"}
              type="legacy"
              flat />
          </Tooltip>
        </div>

      </OwcListItem>
      {filterList.map((filter) => {
        const filterUrl = item.url + "/" + filter.filterId;
        const isFilterActive = location.pathname === filterUrl;

        return (((filter.isChecked && isExpanded) || (isEdit && filter?.filterName))) && <OwcListItem
          key={filter.filterId}
          selected={isFilterActive}
          onClick={() => handleRedirect({ ...item, url: filterUrl })}
          noBorder
          disabled={item.disable}
        >
          <div slot="icon" style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', width: '1.5rem'
          }}>
            <div style={{
              width: '1px',
              minHeight: '3rem',
              backgroundColor: 'rgba(194, 186, 181, 1)',
            }} />
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ marginLeft: 15 }}>{filter.filterName}</span>
            {isEdit &&
              <OwcIconButton
                style={{ marginLeft: "auto" }}
                onClick={(e) => {
                  e.stopPropagation();
                  const newFilterList = filterList.map((f) =>
                    f.filterId === filter.filterId
                      ? { ...f, isChecked: !f.isChecked }
                      : f
                  );
                  setFilterList(newFilterList);

                }}
                icon={filter.isChecked ? "element_show" : "element_hide"}
                type="legacy"
                flat
              />}
          </div>
        </OwcListItem>
      })}

    </div>
  )
}

export default withApollo(GroupListItem)
